// src/utils/cryptoUtils.js
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../../config.js"; // Make sure this exists and exports a value

// AES encryption
export const encryptData = (data) => {
  return data
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

// AES decryption
export const decryptData = (Cyphertext) => {
  return Cyphertext
  try {
    const bytes = CryptoJS.AES.decrypt(Cyphertext, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

// export const decryptData = (ciphertext) => {
//   const bytes = CryptoJS.AES.decrypt(ciphertext, constant.CONST_CRYPTO_SECRET);
//   const decrypted = bytes.toString(CryptoJS.enc.Utf8);
//   return JSON.parse(decrypted);
// };

// Handle encryption for both FormData and plain objects
export const processEncryptPayload = (input) => {
  return input
  if (input instanceof FormData) {
    const plainData = {};
    const binaryKeys = [];

    // Extract binaries and plain fields
    input.forEach((value, key) => {
      if (value instanceof File || value instanceof Blob) {
        binaryKeys.push({ key, value });
      } else {
        plainData[key] = value;
      }
    });

    const encryptedPayload = encryptData(plainData);

    const newFormData = new FormData();
    binaryKeys.forEach(({ key, value }) => {
      newFormData.append(key, value);
    });
    newFormData.append("payload", encryptedPayload);

    return newFormData;
  }

  // Plain object
  return { payload: encryptData(input) };
};



// {{ JSON.stringify([
//     {
//   sale_booking_id: "",
//   sales_service_master_id: $fromAI("service_id1"),
//   amount: Number($fromAI("service_amount1") || 0),

//   created_by: Number($fromAI("secret_code") || 1049)
// },
//     {
//   sale_booking_id: "",
//   sales_service_master_id: $fromAI("service_id2"),
//   amount: Number($fromAI("service_amount2") || 0),

//   created_by: Number($fromAI("secret_code") || 1049)
// },
//     {
//   sale_booking_id: "",
//   sales_service_master_id: $fromAI("service_id3"),
//   amount: Number($fromAI("service_amount3") || 0),

//   created_by: Number($fromAI("secret_code") || 1049)
// },
//     {
//   sale_booking_id: "",
//   sales_service_master_id: $fromAI("service_id4"),
//   amount: Number($fromAI("service_amount4") || 0),

//   created_by: Number($fromAI("secret_code") || 1049)
// },
//     {
//   sale_booking_id: "",
//   sales_service_master_id: $fromAI("service_id5"),
//   amount: Number($fromAI("service_amount5") || 0),

//   created_by: Number($fromAI("secret_code") || 1049)
// }
// ]) }}
